import React from 'react';
import classNames from 'classnames';
import bowser from 'yola-bowser';
import Button from '../button';

class VoteForFeature extends React.Component {
  voteForFeatureScrollerRef;

  static defaultProps = {
    captions: {
      title: 'Vote for this feature',
      description: '',
      vote: 'Vote now',
    },
    // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string | undefined'.
    href: null,
    target: 'blank',
    onVoteClick: Function.prototype,
  };

  constructor(props) {
    super(props);
    this.voteForFeatureScrollerRef = React.createRef();
    this.state = {
      isScrollable: false,
    };

    this.setIsScrollable = this.setIsScrollable.bind(this);
  }

  componentDidMount() {
    this.setIsScrollable();
    window.addEventListener('resize', this.setIsScrollable);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setIsScrollable);
  }

  setIsScrollable() {
    const { current } = this.voteForFeatureScrollerRef;
    this.setState({ isScrollable: current.scrollHeight > current.offsetHeight });
  }

  render() {
    const { captions, imageUrl, href, target, onVoteClick } = this.props;
    const { isScrollable } = this.state;

    return (
      <div
        className={classNames('ws-vote-for-feature', {
          'ws-vote-for-feature--mobile': bowser.mobile,
        })}
      >
        <div
          className={classNames('ws-vote-for-feature__scroller', {
            'ws-vote-for-feature__scroller--centred': !isScrollable,
          })}
          ref={this.voteForFeatureScrollerRef}
        >
          <div
            className="ws-vote-for-feature__image"
            style={{
              backgroundImage: `url(${imageUrl})`,
            }}
          >
            <div className="ws-vote-for-feature__image-overlay" />
          </div>
          <div className="ws-text ws-text--type-heading-2 ws-text--theme-default ws-vote-for-feature__title">
            {captions.title}
          </div>
          <div className="ws-text ws-text--type-heading-5 ws-text--theme-default ws-vote-for-feature__description">
            {captions.description}
          </div>
        </div>

        <div className="ws-vote-for-feature__button-container">
          <Button type="primary" size="large" href={href} target={target} onClick={onVoteClick}>
            {captions.vote}
          </Button>
        </div>
      </div>
    );
  }
}

export default VoteForFeature;
